import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import PlatformAPIEventType from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIEventType";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import GameModel from "../model/GameModel";
import PuzzleStatus from "../model/PuzzleStatus";
import SaveModel from "../model/SaveModel";


export default class StartGameCommand extends AbstractCommand {

    /**
     * 
     * @param {*} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, saveModel, gameModel) {
        super(dispatcher);

        this.execute = function(event) {
            const savegame = saveModel.getSaveGame();
            if (savegame && savegame.index == gameModel.puzzleCount-1 && savegame.puzzle.status == PuzzleStatus.COMPLETED) {
                this.gotoScreen(SkinKeys.END_SCREEN_SKIN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN_SKIN);
            }
        };
    };

}